var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYellowArrow = function SvgYellowArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "m17.31 9.254 7.004 6.966c.43.428.43 1.121 0 1.549l-7.005 6.966a1.105 1.105 0 0 1-1.557 0 1.09 1.09 0 0 1 0-1.548l5.126-5.098h-9.817V15.9h9.817l-5.126-5.097a1.09 1.09 0 0 1 0-1.548 1.105 1.105 0 0 1 1.557 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "M9.363 16.996c0-.703.428-1.272.955-1.272h10.818c.528 0 .955.57.955 1.272s-.427 1.273-.955 1.273H10.318c-.527 0-.955-.57-.955-1.273",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8D057",
    d: "M34 17c0 9.389-7.611 17-17 17S0 26.389 0 17 7.611 0 17 0s17 7.611 17 17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "m17.31 9.254 7.004 6.966c.43.428.43 1.121 0 1.549l-7.005 6.966a1.105 1.105 0 0 1-1.557 0 1.09 1.09 0 0 1 0-1.548l5.126-5.098h-9.817V15.9h9.817l-5.126-5.097a1.09 1.09 0 0 1 0-1.548 1.105 1.105 0 0 1 1.557 0",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "M9.363 16.996c0-.703.428-1.272.955-1.272h10.818c.528 0 .955.57.955 1.272s-.427 1.273-.955 1.273H10.318c-.527 0-.955-.57-.955-1.273",
    clipRule: "evenodd"
  })));
};
export default SvgYellowArrow;